import React, {useCallback} from "react";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import {dismissSystemBroadcastMessage} from "../../systemBroadcastMessageActions";

const SystemBroadcastMessage = () => {
    const {message, hidden} = useSelector(state => state.systemBroadcastMessage);
    const dispatch = useDispatch();
    const onDismiss = useCallback(e => {
        dispatch(dismissSystemBroadcastMessage());
    }, []);

    if (!message || hidden)
        return null;

    return (
        <Wrapper>
            <Message>{message}</Message>
            <DismissButton className="t-dismiss-button" onClick={onDismiss}>
                &times;
            </DismissButton>
        </Wrapper>
    );
};

export default SystemBroadcastMessage;

const backgroundColor = "#545454";
const foregroundColor = "#e1dbd5";

const Wrapper = styled.div`
padding: 0 18px;
background-color: ${backgroundColor};
display: flex;
flex-direction: row;
`;

export const Message = styled.div`
padding: 7px 12px;
text-decoration: none;
font-weight: bold;
color: ${foregroundColor};
flex-grow: 1;
`;

export const DismissButton = styled.div`
justify-content: flex-end;
cursor: pointer;
margin-right: 10px;
font-size: 28px;
color: ${foregroundColor};
line-height: 36px;
`;
